import _ from "lodash";
import { createSelector } from "reselect";
import { IRootState } from "../../app/types/rootReducers.t";
import { getAppFeatures } from "../../app/appSelectors";
import { FEATURES } from "../../app/appConstants";

const tutorialsSelector = (state: IRootState) => state.tutorials;

export const getIsTutorialsInitedSelector = createSelector(
    tutorialsSelector, tutorials => tutorials.isInited,
);

export const getIsShowWatchMoreVideosLaterTooltipSelector = createSelector(
    tutorialsSelector, tutorials => tutorials.isShowWatchMoreVideosLaterTooltip,
);

export const getIsFirstShowIntroSelector = createSelector(
    tutorialsSelector, tutorials => tutorials.isFirstShowIntro,
);

export const getTutorialsListSelector = createSelector(
    tutorialsSelector, tutorials => tutorials.tutorialsList,
);

export const makeSelectTutorialsItemByName = (name: string) => createSelector(
    getTutorialsListSelector, tutorialsList => _.find(tutorialsList, { name }),
);

export const getIsTutorialsLoadingSelector = createSelector(
    tutorialsSelector, tutorials => tutorials.isTutorialsLoading,
);

export const getIsShowBeginnersGuideInviteSelector = createSelector(
    tutorialsSelector, tutorials => tutorials.isShowBeginnersGuideInvite,
);

export const getIsBeginnersGuideEnabledSelector = createSelector(
    getAppFeatures, (appFeatures) => appFeatures[FEATURES.BEGINNERS_GUIDE],
);

export const getIsTutorialsEnabledSelector = createSelector(
    getAppFeatures, (appFeatures) => appFeatures[FEATURES.TUTORIALS],
);
